import { ReactNode } from 'react';
import { IdeasWraper } from '../components/ideas';
import Inbox from '../components/requestsInbox/index';
import EvidenceRouting from '../components/EvidenceRouting';
import Dashboard from '../components/dashboard';
import { DashboardContextProvider } from '../components/dashboard/DashboardContext';
import NewIdeaView from '../components/ideaNiv/NewIdeaView';
import { IdeaContextProvider } from '../components/ideaNiv/IdeaContext';
import { FiltersContextProvider } from '../components/ideas/filters/context/FiltersContext';
import Discovery from '../components/Discovery/Discovery';
import { DiscoveryContextProvider } from '../components/Discovery/DiscoveryContext';
import CustomerView from '../components/Customer360';
import { SingleCustomerContextProvider } from '../components/Customer360/Customer-Context/SingleCustomerContext';
import TopRequests from '../components/reports/TopRequests/Index';
import Account from '../components/settings';
import { Integrations } from '../components/settings/integrations/Integrations';
import { IntegrationsList } from '../components/settings/integrations2.0/pages/IntegrationsList';
import { IntegrationDetail } from '../components/settings/integrations2.0/pages/IntegrationDetail';
import { CompleteIntegrationAuth } from '../components/settings/integrations2.0/pages/CompleteIntegrationAuth';
import Integration from '../components/settings/integrations/Integration';
import PIIRedactionSettings from '../components/settings/pii-reduction';
import MLSettings from '../components/settings/ml-settings';
import Teams from '../components/settings/Teams';
import Members from '../components/settings/Members';
import ImportIdeasEvidence from '../components/ImportIdeasEvidence';
import ImportItems from '../components/ImportItems';
import ExportIdeas from '../components/ExportIdeas';
import ExportItems from '../components/ExportItems';
import ProductAreas from '../components/settings/ProductArea/ProductAreas';
import TagsManager from '../components/tags/TagsManager';
import PropertyManager from '../components/settings/PropertyManager';
import Objects from '../components/settings/objects/ObjectsAndFields';
import Tokens from '../components/settings/Tokens';
import Object from '../components/settings/objects/Object';
import Idea from '../components/settings/objects/Idea';
// import { CompleteIntegrationAuth as CompleteIntegrationAuthLegacy } from '../components/settings/CompleteIntegrationAuth';

import AuthCallback from '../components/AuthCallback';
import FiltersAndSegmentes from '../components/settings/filters-and-segments';
import { FiltersAndSegmentsContextContextProvider } from '../components/settings/filters-and-segments/FiltersAndSegmentsContext';
import { AdminProtectedRoute } from '../components/AdminProtectedRoute';
import Notifications from '../components/settings/notifications';
export interface RouteConfig {
  path: string;
  element: ReactNode;
  key?: string;
  children?: RouteConfig[];
}

// Base routes that are always available
const baseRoutes: RouteConfig[] = [
  {
    path: '/',
    element: <IdeasWraper pageKey="all" />,
  },
  {
    path: '/inbox',
    element: <Inbox />,
  },
  {
    path: '/ideas',
    element: <IdeasWraper pageKey="all" />,
  },
  {
    path: '/evidence/:id',
    element: <EvidenceRouting />,
  },
  {
    path: '/evidence/:id/comment/:commentId',
    element: <EvidenceRouting />,
  },
  {
    path: '/evidence',
    element: <EvidenceRouting />,
  },
  {
    path: '/ideas/all',
    element: <IdeasWraper pageKey="all" />,
  },
  {
    path: '/ideas/archived',
    element: <IdeasWraper pageKey="archived" />,
  },
  {
    path: '/trends',
    element: (
      <DashboardContextProvider>
        <Dashboard />
      </DashboardContextProvider>
    ),
  },
  {
    path: '/idea/:id',
    element: (
      <IdeaContextProvider>
        <FiltersContextProvider>
          <NewIdeaView />
        </FiltersContextProvider>
      </IdeaContextProvider>
    ),
  },
  {
    path: '/discovery',
    element: (
      <FiltersContextProvider>
        <DiscoveryContextProvider>
          <Discovery />
        </DiscoveryContextProvider>
      </FiltersContextProvider>
    ),
  },
  {
    path: '/customer360',
    element: (
      <SingleCustomerContextProvider>
        <CustomerView />
      </SingleCustomerContextProvider>
    ),
  },
  {
    path: '/customer360/:id',
    element: (
      <SingleCustomerContextProvider>
        <CustomerView />
      </SingleCustomerContextProvider>
    ),
  },
  {
    path: '/reports',
    element: <TopRequests />,
    children: [
      {
        path: 'top-requests',
        element: <TopRequests />,
      },
    ],
  },
];

// Settings routes
const settingsRoutes: RouteConfig[] = [
  {
    path: '/settings',
    element: <AdminProtectedRoute><Account /></AdminProtectedRoute>,
  },
  {
    path: '/settings/account',
    element: <AdminProtectedRoute><Account /></AdminProtectedRoute>,
  },
  {
    path: '/settings/integrations',
    element: <AdminProtectedRoute><Integrations /></AdminProtectedRoute>,
  },
  {
    path: '/settings/integrations2.0',
    element: <AdminProtectedRoute><IntegrationsList /></AdminProtectedRoute>,
  },
  {
    path: '/settings/integrations2.0/:key',
    element: <AdminProtectedRoute><IntegrationDetail /></AdminProtectedRoute>,
  },
  {
    path: '/settings/integrations2.0/:key/complete',
    element: <AdminProtectedRoute><CompleteIntegrationAuth /></AdminProtectedRoute>,
  },
  {
    path: '/settings/integrations/:type',
    element: <AdminProtectedRoute><Integration /></AdminProtectedRoute>,
  },
  {
    path: '/settings/pii-redaction',
    element: <AdminProtectedRoute><PIIRedactionSettings /></AdminProtectedRoute>,
  },
  {
    path: '/settings/ml-settings',
    element: <AdminProtectedRoute><MLSettings /></AdminProtectedRoute>,
  },
  {
    path: '/settings/teams',
    element: <AdminProtectedRoute><Teams /></AdminProtectedRoute>,
  },
  {
    path: '/settings/members',
    element: <AdminProtectedRoute><Members /></AdminProtectedRoute>,
  },
  {
    path: '/settings/import/ideas_evidence',
    element: <AdminProtectedRoute><ImportIdeasEvidence /></AdminProtectedRoute>,
  },
  {
    path: '/settings/import/items',
    element: <AdminProtectedRoute><ImportItems /></AdminProtectedRoute>,
  },
  {
    path: '/settings/export/ideas',
    element: <AdminProtectedRoute><ExportIdeas /></AdminProtectedRoute>,
  },
  {
    path: '/settings/export/items',
    element: <AdminProtectedRoute><ExportItems /></AdminProtectedRoute>,
  },
  {
    path: '/settings/productareas',
    element: <AdminProtectedRoute><ProductAreas /></AdminProtectedRoute>,
  },
  {
    path: '/settings/tags',
    element: <AdminProtectedRoute><TagsManager /></AdminProtectedRoute>,
  },
  {
    path: '/settings/property',
    element: <AdminProtectedRoute><PropertyManager /></AdminProtectedRoute>,
  },
  {
    path: '/settings/objects',
    element: <AdminProtectedRoute><Objects /></AdminProtectedRoute>,
  },
  {
    path: '/settings/filters',
    element: <AdminProtectedRoute>
      <FiltersAndSegmentsContextContextProvider>
        <FiltersAndSegmentes />
      </FiltersAndSegmentsContextContextProvider>
    </AdminProtectedRoute>,
  },
  {
    path: '/settings/tokens',
    element: <AdminProtectedRoute><Tokens /></AdminProtectedRoute>,
  },
  {
    path: '/settings/notifications',
    element:<AdminProtectedRoute><Notifications /></AdminProtectedRoute>,
  },
  {
    path: '/settings/objects/:slug',
    element: <AdminProtectedRoute><Object /></AdminProtectedRoute>,
  },
  {
    path: '/settings/objects/idea/:ideaObject',
    element: <AdminProtectedRoute><Idea /></AdminProtectedRoute>,
  },
];

// Additional routes
const additionalRoutes: RouteConfig[] = [
  {
    path: '/newIntegration',
    element: <CompleteIntegrationAuth />,
  },
  {
    path: '/postLogin',
    element: <AuthCallback />,
  },
];

// Custom routes
const customRoutes: RouteConfig[] = [
  //TODO: add custom routes here
];

// Combine all routes
export const routes: RouteConfig[] = [
  ...baseRoutes,
  ...settingsRoutes,
  ...additionalRoutes,
  // ...customRoutes,
];